import { useState } from "react";

const Instructions = () => {
  const [showInstructions, setShowInstructions] = useState(false);
  return (
    <>
      <div className="cursor-pointer font-bold mt-3" onClick={() => { setShowInstructions(true) }} >How to play</div>
      {showInstructions && (
        <div onClick={() => { setShowInstructions(false) }} className="absolute w-full h-full bg-black/90">
          <div className="flex flex-col mt-20 items-center w-full h-full text-white">
            <div className="w-[300px] flex flex-col">
              <svg className="self-end mb-3 cursor-pointer" width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.41274 0.49823L0 3.91097L1.74268 5.65364L6.05096 10.0345L1.74268 14.3428L0 16.0129L3.41274 19.4982L5.15541 17.7556L9.53631 13.3747L13.8446 17.7556L15.5146 19.4982L19 16.0129L17.2573 14.3428L12.8764 10.0345L17.2573 5.65364L19 3.91097L15.5146 0.49823L13.8446 2.24091L9.53631 6.54919L5.15541 2.24091L3.41274 0.49823Z" fill="white" /></svg>
              <h3 className="font-bold">Explanation</h3>
              <p className="mb-3">Use the buttons at the bottom to change the color of the top left tile. Any tiles connected to it will change too. Connect the whole board to complete the game.</p>
              <h3 className="font-bold">Daily</h3>
              <p className="mb-3">This board is the same for everyone and updates every day. Try to get the high score by using the fewest moves!</p>
              <h3 className="font-bold">Small, Medium, Large</h3>
              <p className="mb-3">Different sized boards. Each time you complete it, you get one less move.</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
 
export default Instructions;
